// @ts-nocheck
import * as React from "react";

const EyeOffFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.29 3.29a1.004 1.004 0 0 1 1.42 0l3.18 3.18 4.028 4.032a1.496 1.496 0 0 1 1.58 1.581L17.41 16l2 2 1.3 1.29a1.002 1.002 0 0 1 0 1.42 1.002 1.002 0 0 1-1.42 0L16.59 18l-2-2-2.507-2.502c-.411.022-.83-.123-1.144-.437a1.496 1.496 0 0 1-.437-1.141L7.28 8.7 5.53 7 3.29 4.71l-.084-.095A1.004 1.004 0 0 1 3.29 3.29ZM5 7.87l1.56 1.52 2 2a4.07 4.07 0 0 0-.06.61v.05a3.5 3.5 0 0 0 3.55 3.45l.204-.01a4.07 4.07 0 0 0 .406-.05L14 16.78l1.29 1.34.21.21a9.48 9.48 0 0 1-3.23.67h-.25c-5.89 0-9.26-5.41-9.89-6.5a1 1 0 0 1 0-1l.265-.443A15.89 15.89 0 0 1 5 7.87Zm7.079-2.874c5.422.038 8.748 4.79 9.648 6.264l.102.17.041.07a1 1 0 0 1 0 1l-.27.444a15.89 15.89 0 0 1-2.64 3.186l-3.52-3.52a4.07 4.07 0 0 0 .06-.61l-.005-.192A3.5 3.5 0 0 0 12 8.5l-.204.01a4.07 4.07 0 0 0-.406.05L8.5 5.67A9.48 9.48 0 0 1 11.73 5Z"
            />
        </svg>
    );
};

export default React.memo(EyeOffFill);
